import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import BellIcon from '../img/bell-regular-active.svg'; // Importar el icono aquí

import * as API from "../services/notificaciones";


export default function NotificationIcon(props) {
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      if(props.especialistaId) {
        try {
          const val = await API.getUnreadNotifications(props.especialistaId);
          setUnreadCount(val);
        } catch (error) {
          console.error('Error fetching unread notifications:', error);
        }
      }
    };

    fetchData();

    const interval = setInterval(() => {
      fetchData();
    }, 300000); // Actualiza cada 5 minutos

    return () => clearInterval(interval);
  }, [setUnreadCount]);

  const notificationLink = props.userRole.includes("paciente") 
    ? '../perfil/notificaciones' 
    : '../notificaciones';

  return (
    <NavLink className={unreadCount > 0 ? 'unread' : ''} to={notificationLink}>
        <img src={BellIcon} alt="Icono de campana" style={{ width: '20px', height: '18px' }} />
        {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
    </NavLink>
  );
};